import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "capitalize" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "completed", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "capitalize" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "not completed", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "font-medium text-red-500" }, "The associated completion certificate has automatically been sent. You may need to contact the attendee directly to explain the reversal.")
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "paid", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "capitalize" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "unpaid", -1)
const _hoisted_14 = { class: "flex justify-between space-x-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "You will only be able to manage delegates once your invoice is paid.", -1)
const _hoisted_16 = { class: "flex justify-end" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "w-full mt-8 overflow-x-auto min-h-[420px]" }
const _hoisted_19 = { class: "w-full table-auto h-fit" }
const _hoisted_20 = { class: "font-bold text-left capitalize border-b-2 border-black" }
const _hoisted_21 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_22 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_23 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_24 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_25 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_26 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_27 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_28 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_29 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_30 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_31 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_32 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_33 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_34 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_35 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_36 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_37 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_38 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_39 = {
  key: 0,
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_40 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_41 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_42 = {
  key: 1,
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_43 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_44 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_45 = {
  key: 2,
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_46 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_47 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_48 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_49 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_50 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_51 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_52 = { class: "flex items-center space-x-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-2 py-2"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "hidden" }, "Actions")
], -1)
const _hoisted_54 = { class: "px-2 py-6 md:py-3 whitespace-nowrap" }
const _hoisted_55 = { class: "capitalize" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "capitalize" }
const _hoisted_59 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_60 = { class: "text-sm text-gray-700" }
const _hoisted_61 = { class: "px-2 py-2 capitalize" }
const _hoisted_62 = { class: "px-4 py-2 capitalize md:px-2" }
const _hoisted_63 = { class: "px-4 py-2 capitalize md:px-2" }
const _hoisted_64 = {
  key: 0,
  class: "px-2 py-2 capitalize"
}
const _hoisted_65 = {
  key: 1,
  class: "px-2 py-2 capitalize"
}
const _hoisted_66 = {
  key: 2,
  class: "px-4 py-2 capitalize md:px-2"
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["checked", "value"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { class: "px-2 text-sm text-white rounded-full bg-success w-fit" }
const _hoisted_73 = { class: "px-4 py-2 capitalize md:px-2" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["checked", "value"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_79 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_80 = { key: 2 }
const _hoisted_81 = { class: "px-4 py-2 capitalize md:px-2" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = ["checked", "value"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = ["checked", "value"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_90 = { key: 0 }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["checked", "value"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)
const _hoisted_94 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_95 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_96 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_97 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_98 = { class: "px-2 py-2" }
const _hoisted_99 = { class: "flex space-x-4" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("td", { class: "py-2" }, "No users have currently registered", -1)
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = { class: "flex items-center w-full pb-4 mt-10" }
const _hoisted_105 = { class: "flex flex-wrap items-center justify-center mx-auto space-y-2 md:space-y-0" }
const _hoisted_106 = { class: "flex" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  class: "w-4",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
  })
], -1)
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = ["onClick"]
const _hoisted_110 = ["onClick"]
const _hoisted_111 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "w-4",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
  })
], -1)
const _hoisted_112 = [
  _hoisted_111
]

import { PropType, computed, ref } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";

import RedeemLicenseModal from "@/components/modals/RedeemLicenseModal.vue";
import TrainerManualAdd from "../modals/TrainerManualAdd.vue";
import ManualBookingModal from "@/components/modals/ManualBookingModal.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SortableTableHeader from "./SortableTableHeader.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import FilterTableHeader from "./FilterTableHeader.vue";
import RoleGuard from "../RoleGuard.vue";

import api from "@/api/api";
import { userHasRole } from "@/utils/roles";
import { useGlobalStore, useUserStore } from "@/store";
import { Booking, Event, PaginationMeta } from "@/types";
import { useFilters } from "@/composables/filters";
import PaymentStatusBadge from "../PaymentStatusBadge.vue";
import SearchTableHeader from "./SearchTableHeader.vue";
import SearchSubOrgTableHeader from "./SearchSubOrgTableHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventAttendeesTable',
  props: {
  event: {
    type: Object as PropType<Event>,
    required: true,
  },
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;

const route = useRoute();

const globalStore = useGlobalStore();
const { user, userIsAdmin } = storeToRefs(useUserStore());
const { countries } = storeToRefs(globalStore);
const { filters, setFilter, resetFilters, sortBy, filter, getFiltersFromQuery, setFilterNoRefresh } = useFilters(route);

const locations = countries.value.map(c => c.name);



const isAttendenceConfirmationOpen = ref(false);
const isRedeemLicenseModalOpen = ref(false);
const isRemoveAttendeeModalOpen = ref(false);
const isPaymentConfirmationOpen = ref(false);
const isManualBookingModalOpen = ref(false);
const isManualTrainerBookingModalOpen = ref(false);
const isUpdatingBooking = ref(false);

const addedByUser = ref(true);
const organisations = ref([] as string[]);
const platforms = ref([] as string[]);
const statusFilters = ["abandoned", "confirmed", "pending", "refunded", "paid"];
const gateways = ["Stripe", "2Checkout", "Manual"];

const licenses = ref({
  available: {
    total: 0,
    allocations: 0,
    ids: [],
  },
  pending: {
    total: 0,
    allocations: 0,
    ids: [],
  },
});

const users = ref([] as { id: string; email: string; name: string }[]);
const attendees = ref([] as Booking[]);
const meta = ref({} as PaginationMeta);
const selectedAttendee = ref({} as Booking);

const paginationArray = ref([] as number[]);

const hasLicenseAvailable = computed(() => licenses.value.available.total - licenses.value.available.allocations > 0);

const userInOrg = computed(() => user.value.organisation_id === props.event.organisation_id && userHasRole(user.value.roles, ["trainer-organisation", "l4a-trainer"]));

const shouldShowColumn = computed(() => {
  // If user is admin, show all columns
  if (userHasRole(user.value.roles, ["admin", "courses-admin", "users-admin", "clubs-admin"])) {
    return true;
  }

  // If event is in same organisation as user and user is TO/FO
  if (user.value.organisation_id === props.event.organisation_id && userHasRole(user.value.roles, ["trainer-organisation", "l4a-trainer"])) {
    return true;
  }

  // Anything else, do not show the column
  return false;
});

async function goToPage(p: number) {
  filters.value.page = p;
  return await filter();
}

function getMiddlePages(total_pages: number) {
  // return 3 pages before and after current page
  const currentPage = Number(filters.value.page);

  for (let i = currentPage - 3; i <= currentPage + 3; i++) {
    if (i > 0 && i <= total_pages && i !== 1) {
      paginationArray.value.push(i);
    }
  }
}

const filteredAttendees = computed(() => {
  return attendees.value.filter(i => {
    /** Only users in group who didn't book the event (delegates) */
    if (i.type === "group" && i.transaction) {
      if (i.user_id === i.transaction.user_id) {
        return false;
      }
    }

    /** Only users in group who didn't book the event (delegates) */
    if (i.type === "group" && i.payment_method === "Invoice") {
      return i.is_delegate;
    }

    return true;
  });
});

async function markAsInvoiceIssued(id: number) {
  try {
    const response = await api.bookings.toggleBookingInvoiceIssued(id);

    const issued = response.data.booking.invoice_issued ? "issued" : "not issued";

    await listBookings();

    globalStore.toast("SUCCESS", `Invoice marked as ${issued}`);
  } catch (error) {
    globalStore.toast("ERROR", `Error updating Licence`);
  }
}

function updateAttendanceConfirmation(attendee: Booking) {
  if (!attendee.payment_confirmed) return;
  if (attendee.is_refunded) return;

  selectedAttendee.value = attendee;
  isAttendenceConfirmationOpen.value = true;
}

function updatePaymentStatusConfirmation(attendee: Booking) {
  if (attendee.invoice_total_amount === 0) {
    console.log("Course is free");
    return;
  }

  selectedAttendee.value = attendee;
  isPaymentConfirmationOpen.value = true;
}

async function updateAttendance(attendee: Booking) {
  isUpdatingBooking.value = true;

  try {
    await api.bookings.updateBookingAttendance(attendee.id, { user_attended: attendee.user_attended });
    await listBookings();

    globalStore.toast("SUCCESS", "User attendance updated");
  } catch (e) {
    globalStore.toast("ERROR", "Error updating user attendance");
    isAttendenceConfirmationOpen.value = false;
  }

  isUpdatingBooking.value = false;
  isAttendenceConfirmationOpen.value = false;
}

async function removeAttendee(attendee: Booking) {
  try {
    await api.bookings.removeAttendee(attendee.id);
    await listBookings();
    await getAvailableLicense();

    globalStore.toast("SUCCESS", "Attendee removed");
  } catch (e) {
    globalStore.toast("ERROR", "Error removing Attendee");
    isRemoveAttendeeModalOpen.value = false;
  } finally {
    isRemoveAttendeeModalOpen.value = false;
    isUpdatingBooking.value = false;
  }
}

async function updatePaymentStatus(attendee: Booking) {
  isUpdatingBooking.value = true;
  try {
    (await api.bookings.updateBookingPayment(attendee.id, { payment_confirmed: attendee.payment_confirmed })).data.booking;
    await listBookings();

    globalStore.toast("SUCCESS", "User's payment status updated");
  } catch (e) {
    globalStore.toast("ERROR", "Error updating user's payment status");
  }

  isUpdatingBooking.value = false;
  isPaymentConfirmationOpen.value = false;
}

/**
 * Get the available license for the event based
 */
async function getAvailableLicense() {
  const response = (await api.license.getLicensesByEvent(userIsAdmin ? props.event.organisation_id : user.value.organisation_id, props.event.id)).data;

  licenses.value = response;
}

async function listBookings() {
  const response = await api.bookings.listBookings(filters.value);
  attendees.value = response.data.bookings;
  meta.value = response.meta;

  organisations.value = response.data.organisations;
  platforms.value = response.data.platforms;
  users.value = response.data.users;
}

async function refresh() {
  await listBookings();
  await getAvailableLicense();
}

if (userHasRole(user.value.roles, ["l4a-trainer", "trainer-organisation", "admin", "facilitator-organisation", "courses-admin"])) {
  getFiltersFromQuery();
  setFilterNoRefresh("tab", "registered_attendees");
  setFilterNoRefresh("added_by_user", addedByUser.value ? "true" : "false");
  setFilterNoRefresh("event_id", props.event.id.toString());

  setFilterNoRefresh("added_by_user", addedByUser.value && props.event.is_play_event ? "true" : "false");
  ;(
  ([__temp,__restore] = _withAsyncContext(() => listBookings())),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => getAvailableLicense())),
  await __temp,
  __restore()
);
}

getMiddlePages(meta.value.pagination.total_pages);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ManualBookingModal, {
      event: __props.event,
      isOpen: isManualBookingModalOpen.value,
      onCreate: listBookings,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isManualBookingModalOpen.value = false))
    }, null, 8, ["event", "isOpen"]),
    _createVNode(RedeemLicenseModal, {
      event: __props.event,
      isOpen: isRedeemLicenseModalOpen.value,
      licenses: licenses.value,
      onCreate: refresh,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isRedeemLicenseModalOpen.value = false))
    }, null, 8, ["event", "isOpen", "licenses"]),
    _createVNode(TrainerManualAdd, {
      event: __props.event,
      isOpen: isManualTrainerBookingModalOpen.value,
      onCreate: refresh,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (isManualTrainerBookingModalOpen.value = false))
    }, null, 8, ["event", "isOpen"]),
    _createVNode(ConfirmationModal, {
      isOpen: isAttendenceConfirmationOpen.value,
      isLoading: isUpdatingBooking.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (isAttendenceConfirmationOpen.value = false)),
      onDelete: _cache[4] || (_cache[4] = ($event: any) => (updateAttendance(selectedAttendee.value))),
      buttonText: !selectedAttendee.value.user_attended ? 'Confirm course completion' : 'Confirm reversal of the <strong>COMPLETION</strong>'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (!selectedAttendee.value.user_attended)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", null, [
                  _createTextVNode(" This will mark the attendee "),
                  _createElementVNode("strong", _hoisted_2, _toDisplayString(selectedAttendee.value.user.first_name) + " " + _toDisplayString(selectedAttendee.value.user.last_name), 1),
                  _createTextVNode(" as having "),
                  _hoisted_3,
                  _createTextVNode(" the course and will send their associated certificate. ")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", null, [
                  _createTextVNode(" This will mark the attendee "),
                  _createElementVNode("strong", _hoisted_5, _toDisplayString(selectedAttendee.value.user.first_name) + " " + _toDisplayString(selectedAttendee.value.user.last_name), 1),
                  _createTextVNode(" as having "),
                  _hoisted_6,
                  _createTextVNode(" the course. ")
                ]),
                _hoisted_7
              ]))
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "isLoading", "buttonText"]),
    _createVNode(ConfirmationModal, {
      isOpen: isPaymentConfirmationOpen.value,
      isLoading: isUpdatingBooking.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (isPaymentConfirmationOpen.value = false)),
      onDelete: _cache[6] || (_cache[6] = ($event: any) => (updatePaymentStatus(selectedAttendee.value))),
      buttonText: !selectedAttendee.value.payment_confirmed ? 'Confirm user has paid' : 'Confirm reversal'
    }, {
      default: _withCtx(() => [
        (!selectedAttendee.value.payment_confirmed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", null, [
                _createTextVNode(" This will mark the attendee "),
                _createElementVNode("strong", _hoisted_9, _toDisplayString(selectedAttendee.value.user.first_name) + " " + _toDisplayString(selectedAttendee.value.user.last_name), 1),
                _createTextVNode(" as having "),
                _hoisted_10,
                _createTextVNode(" and they will receive a welcome email for the course. ")
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("p", null, [
                _createTextVNode(" This will mark the attendee "),
                _createElementVNode("strong", _hoisted_12, _toDisplayString(selectedAttendee.value.user.first_name) + " " + _toDisplayString(selectedAttendee.value.user.last_name), 1),
                _createTextVNode(" as "),
                _hoisted_13,
                _createTextVNode(". ")
              ])
            ]))
      ]),
      _: 1
    }, 8, ["isOpen", "isLoading", "buttonText"]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, [
          _createTextVNode(" Showing "),
          _createElementVNode("strong", null, _toDisplayString(_unref(filteredAttendees).length), 1),
          _createTextVNode(" of "),
          _createElementVNode("strong", null, _toDisplayString(meta.value.pagination?.total_entries), 1),
          _createTextVNode(" attendees ")
        ]),
        (__props.event.is_play_event)
          ? (_openBlock(), _createBlock(RoleGuard, {
              key: 0,
              roles: ['trainer-organisation', 'facilitator-organisation']
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        (__props.event.status === 'published')
          ? (_openBlock(), _createBlock(RoleGuard, {
              key: 0,
              roles: ['admin', 'courses-admin']
            }, {
              default: _withCtx(() => [
                _createVNode(DefaultButton, {
                  class: "ml-auto",
                  type: "primary",
                  onAction: _cache[7] || (_cache[7] = ($event: any) => (isManualBookingModalOpen.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("manual-add-user-to-course")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(userIsAdmin) && _unref(userInOrg) && __props.event.status === 'published')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(DefaultButton, {
                class: "ml-auto",
                type: "primary",
                onAction: _cache[8] || (_cache[8] = ($event: any) => (isManualTrainerBookingModalOpen.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("manual-add-user-to-course")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (__props.event.is_play_event && __props.event.status === 'published')
          ? (_openBlock(), _createBlock(RoleGuard, {
              key: 2,
              roles: ['trainer-organisation', 'facilitator-organisation']
            }, {
              default: _withCtx(() => [
                _createVNode(DefaultButton, {
                  class: "mt-2 ml-auto",
                  type: "primary",
                  onAction: _cache[9] || (_cache[9] = ($event: any) => (isRedeemLicenseModalOpen.value = true)),
                  disabled: !_unref(hasLicenseAvailable)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("redeem-place")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("you-have-licenses-available", [licenses.value && licenses.value.available ? licenses.value.available.total - licenses.value.available.allocations : 0, licenses.value.pending?.total])), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("table", _hoisted_19, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_20, [
            _createElementVNode("th", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("name")), 1),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(SortableTableHeader, {
                    column: "last_name",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"]),
                  _createVNode(SearchTableHeader, {
                    display_property: "name",
                    search_term: "last_name",
                    label: "user_id",
                    filter_property: "id",
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["onChange", "onReset"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("email")), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(SortableTableHeader, {
                    column: "email",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"]),
                  _createVNode(SearchTableHeader, {
                    display_property: "email",
                    search_term: "email",
                    label: "user_id",
                    filter_property: "id",
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["onChange", "onReset"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`type`)), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(SortableTableHeader, {
                    label: "type",
                    column: "type",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"]),
                  _createVNode(FilterTableHeader, {
                    label: "type",
                    currentValue: _unref(filters).type,
                    filters: ['single', 'group'],
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["currentValue", "onChange", "onReset"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`region`)), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(SortableTableHeader, {
                    label: "region",
                    column: "region",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"]),
                  _createVNode(FilterTableHeader, {
                    label: "region",
                    currentValue: _unref(filters).region,
                    filters: _unref(locations),
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`trained-by`)), 1),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(SortableTableHeader, {
                    label: "Organisation",
                    column: "organisation_id",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"]),
                  _createVNode(FilterTableHeader, {
                    label: "organisation_id",
                    currentValue: _unref(filters).organisation_id,
                    filters: organisations.value,
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`organisation`)), 1),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(SortableTableHeader, {
                    label: "Organisation",
                    column: "sub_organisation",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"]),
                  _createVNode(SearchSubOrgTableHeader, {
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["onChange", "onReset"])
                ])
              ])
            ]),
            (_unref(shouldShowColumn))
              ? (_openBlock(), _createElementBlock("th", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`payment-method`)), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(SortableTableHeader, {
                        label: "Payment Method",
                        column: "payment_method",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"]),
                      _createVNode(FilterTableHeader, {
                        label: "method",
                        currentValue: _unref(filters).method,
                        filters: platforms.value,
                        onChange: _unref(setFilter),
                        onReset: _unref(resetFilters)
                      }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (__props.event.is_play_event && _unref(shouldShowColumn))
              ? (_openBlock(), _createElementBlock("th", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`payment-gateway`)), 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(SortableTableHeader, {
                        label: "Payment Method",
                        column: "payment_gateway",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"]),
                      _createVNode(FilterTableHeader, {
                        label: "gateway",
                        currentValue: _unref(filters).gateway,
                        filters: gateways,
                        onChange: _unref(setFilter),
                        onReset: _unref(resetFilters)
                      }, null, 8, ["currentValue", "onChange", "onReset"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(shouldShowColumn))
              ? (_openBlock(), _createElementBlock("th", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`invoice-issued`)), 1),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(SortableTableHeader, {
                        label: "Invoice Issued",
                        column: "invoice_issued",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"]),
                      _createVNode(FilterTableHeader, {
                        label: "invoice_issued",
                        currentValue: _unref(filters).invoice_issued,
                        filters: ['true', 'false'],
                        onChange: _unref(setFilter),
                        onReset: _unref(resetFilters)
                      }, null, 8, ["currentValue", "onChange", "onReset"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`paid`)), 1),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(SortableTableHeader, {
                    label: "status",
                    column: "payment_status",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"]),
                  _createVNode(FilterTableHeader, {
                    label: "status",
                    currentValue: _unref(filters).status,
                    filters: statusFilters,
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters)
                  }, null, 8, ["currentValue", "onChange", "onReset"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("complete")), 1),
                _createVNode(SortableTableHeader, {
                  label: "user_attended",
                  column: "user_attended",
                  onSort: _unref(sortBy)
                }, null, 8, ["onSort"])
              ])
            ]),
            _hoisted_53
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredAttendees), (attendee) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "w-full border-b border-gray-400 even:bg-gray-200",
              key: attendee.id
            }, [
              _createElementVNode("td", _hoisted_54, [
                _createElementVNode("span", _hoisted_55, [
                  (attendee.organisation?.id === _unref(user).organisation?.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createVNode(RoleGuard, { roles: ['trainer-organisation', 'facilitator-organisation'] }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: "text-blue-500",
                              to: { name: 'User_Profile', params: { id: attendee.user.id } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(attendee.user.first_name) + " " + _toDisplayString(attendee.user.last_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(RoleGuard, { "not-roles": ['trainer-organisation', 'facilitator-organisation'] }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(attendee.user.first_name) + " " + _toDisplayString(attendee.user.last_name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(attendee.user.first_name) + " " + _toDisplayString(attendee.user.last_name), 1))
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_58, _toDisplayString(attendee.user.email), 1)
              ]),
              _createElementVNode("td", _hoisted_59, [
                _createTextVNode(_toDisplayString(attendee.type) + " ", 1),
                _createElementVNode("span", _hoisted_60, _toDisplayString(attendee.type === "group" ? `(${attendees.value.filter(i => i.group_id === attendee.group_id && i.is_delegate).length} places)  ${attendee.group_id}` : ""), 1)
              ]),
              _createElementVNode("td", _hoisted_61, _toDisplayString(attendee.user.country), 1),
              _createElementVNode("td", _hoisted_62, _toDisplayString(attendee.organisation ? attendee.organisation.name : null), 1),
              _createElementVNode("td", _hoisted_63, _toDisplayString(attendee.sub_organisation ? attendee.sub_organisation : null), 1),
              (_unref(shouldShowColumn))
                ? (_openBlock(), _createElementBlock("td", _hoisted_64, _toDisplayString(attendee.payment_method), 1))
                : _createCommentVNode("", true),
              (__props.event.is_play_event && _unref(shouldShowColumn))
                ? (_openBlock(), _createElementBlock("td", _hoisted_65, [
                    _createElementVNode("span", null, _toDisplayString(attendee.transaction ? attendee.transaction.payment_gateway : attendee.payment_gateway), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(shouldShowColumn))
                ? (_openBlock(), _createElementBlock("td", _hoisted_66, [
                    ((attendee.payment_method === 'Invoice' && _unref(user).organisation_id === __props.event.organisation_id) || (attendee.payment_method === 'Invoice' && _unref(userIsAdmin)))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _createElementVNode("label", {
                            class: "relative inline-flex items-center cursor-pointer",
                            onClick: ($event: any) => (markAsInvoiceIssued(attendee.id))
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: attendee.invoice_issued,
                              class: "sr-only peer",
                              disabled: "",
                              value: attendee.invoice_issued
                            }, null, 8, _hoisted_69),
                            _hoisted_70
                          ], 8, _hoisted_68)
                        ]))
                      : _createCommentVNode("", true),
                    (attendee.payment_method === 'License')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t("yes")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_73, [
                _createElementVNode("div", null, [
                  (attendee.payment_method === 'Credit/Debit Card')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _createVNode(PaymentStatusBadge, { order: attendee }, null, 8, ["order"])
                      ]))
                    : (_unref(userIsAdmin) || __props.event.organisation_id === _unref(user).organisation_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          (attendee.payment_status !== 'refunded')
                            ? (_openBlock(), _createElementBlock("label", {
                                key: 0,
                                class: "relative inline-flex items-center cursor-pointer",
                                onClick: ($event: any) => (updatePaymentStatusConfirmation(attendee))
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: attendee.payment_confirmed,
                                  class: "sr-only peer",
                                  disabled: "",
                                  value: attendee.payment_confirmed
                                }, null, 8, _hoisted_77),
                                _hoisted_78
                              ], 8, _hoisted_76))
                            : _createCommentVNode("", true),
                          (attendee.payment_status === 'refunded')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, "Refunded"))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                          _createVNode(PaymentStatusBadge, { order: attendee }, null, 8, ["order"])
                        ]))
                ])
              ]),
              _createElementVNode("td", _hoisted_81, [
                _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'users-admin', 'clubs-admin'] }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("label", {
                        class: "relative inline-flex items-center cursor-pointer",
                        onClick: ($event: any) => (updateAttendanceConfirmation(attendee))
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: attendee.user_attended,
                          class: "sr-only peer",
                          disabled: "",
                          value: attendee.user_attended
                        }, null, 8, _hoisted_83),
                        _hoisted_84
                      ], 8, _hoisted_82)
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(RoleGuard, { roles: ['l4a-trainer'] }, {
                  default: _withCtx(() => [
                    (__props.event.trainer_id === _unref(user).id || __props.event.user_id === _unref(user).id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                          (__props.event.level !== 'Certified Facilitator')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                _createElementVNode("label", {
                                  class: "relative inline-flex items-center cursor-pointer",
                                  onClick: ($event: any) => (updateAttendanceConfirmation(attendee))
                                }, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: attendee.user_attended,
                                    class: "sr-only peer",
                                    disabled: "",
                                    value: attendee.user_attended
                                  }, null, 8, _hoisted_88),
                                  _hoisted_89
                                ], 8, _hoisted_87)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024),
                (__props.event.organisation_id === _unref(user).organisation_id)
                  ? (_openBlock(), _createBlock(RoleGuard, {
                      key: 0,
                      roles: ['trainer-organisation', 'facilitator-organisation']
                    }, {
                      default: _withCtx(() => [
                        (__props.event.level !== 'Certified Facilitator' && attendee.user_id !== _unref(user).id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                              _createElementVNode("label", {
                                class: "relative inline-flex items-center cursor-pointer",
                                onClick: ($event: any) => (updateAttendanceConfirmation(attendee))
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: attendee.user_attended,
                                  class: "sr-only peer",
                                  disabled: "",
                                  value: attendee.user_attended
                                }, null, 8, _hoisted_92),
                                _hoisted_93
                              ], 8, _hoisted_91)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (__props.event.organisation_id !== _unref(user).organisation_id && __props.event.trainer_id !== _unref(user).id)
                  ? (_openBlock(), _createBlock(RoleGuard, {
                      key: 1,
                      roles: ['trainer-organisation', 'facilitator-organisation']
                    }, {
                      default: _withCtx(() => [
                        (attendee.user_attended)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, "Yes"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_95, "No"))
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (__props.event.trainer_id !== _unref(user).id)
                  ? (_openBlock(), _createBlock(RoleGuard, {
                      key: 2,
                      "not-roles": ['admin', 'courses-admin', 'users-admin', 'clubs-admin', 'trainer-organisation', 'facilitator-organisation']
                    }, {
                      default: _withCtx(() => [
                        (attendee.user_attended)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, "Yes"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_97, "No"))
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'users-admin', 'clubs-admin'] }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: `/dashboard/courses/events/${__props.event.id}/bookings/${attendee.id}`,
                        class: "text-primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("View")
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _: 2
                  }, 1024),
                  (__props.event.organisation_id === _unref(user).organisation_id)
                    ? (_openBlock(), _createBlock(RoleGuard, {
                        key: 0,
                        roles: ['trainer-organisation', 'l4a-trainer']
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/dashboard/courses/events/${__props.event.id}/bookings/${attendee.id}`,
                            class: "text-blue"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("View")
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (!attendee.user_attended)
                    ? (_openBlock(), _createBlock(RoleGuard, {
                        key: 1,
                        roles: ['admin', 'courses-admin']
                      }, {
                        default: _withCtx(() => [
                          (!attendee.user_attended)
                            ? (_openBlock(), _createBlock(DefaultButton, {
                                key: 0,
                                type: "text-danger",
                                onAction: ($event: any) => (removeAttendee(attendee))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Remove Attendee")
                                ]),
                                _: 2
                              }, 1032, ["onAction"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createVNode(RoleGuard, { roles: ['l4a-trainer'] }, {
                    default: _withCtx(() => [
                      (__props.event.trainer_id === _unref(user).id && !attendee.user_attended)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                            (!attendee.user_attended)
                              ? (_openBlock(), _createBlock(DefaultButton, {
                                  key: 0,
                                  type: "text-danger",
                                  onAction: ($event: any) => (removeAttendee(attendee))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Remove Attendee")
                                  ]),
                                  _: 2
                                }, 1032, ["onAction"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  (!attendee.user_attended && attendee.user_id !== _unref(user).id)
                    ? (_openBlock(), _createBlock(RoleGuard, {
                        key: 2,
                        roles: ['trainer-organisation', 'facilitator-organisation']
                      }, {
                        default: _withCtx(() => [
                          ((attendee.user.organisation_id === _unref(user).organisation_id && attendee.payment_status === 'confirmed') || __props.event.organisation_id === _unref(user).organisation_id)
                            ? (_openBlock(), _createBlock(DefaultButton, {
                                key: 0,
                                type: "text-danger",
                                onAction: ($event: any) => (removeAttendee(attendee))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Remove Attendee")
                                ]),
                                _: 2
                              }, 1032, ["onAction"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128)),
          (!attendees.value.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_101, _hoisted_103))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_104, [
        _createElementVNode("div", _hoisted_105, [
          _createElementVNode("span", null, "Total " + _toDisplayString(meta.value.pagination?.total_entries) + " items", 1),
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("button", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (goToPage(_unref(filters).page - 1))),
              class: _normalizeClass(["flex items-center px-4 py-2 list-none border border-gray-400 rounded-l text-blue", { 'pointer-events-none': _unref(filters).page - 1 <= 0 }])
            }, _hoisted_108, 2),
            (meta.value.pagination.total_pages <= 8)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(meta.value.pagination?.total_pages, (p) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: p,
                    onClick: ($event: any) => (goToPage(p)),
                    class: _normalizeClass([p === _unref(filters).page ? 'text-white bg-primary' : 'text-blue bg-white', "px-4 py-2 list-none border border-gray-400"])
                  }, _toDisplayString(p), 11, _hoisted_109))
                }), 128))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (goToPage(1))),
                    class: "px-4 py-2 list-none bg-white border border-gray-400 text-blue"
                  }, "1"),
                  (meta.value.pagination.current_page > 5)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (goToPage(paginationArray.value[0] - 1))),
                        class: "px-4 py-2 list-none bg-white border border-gray-400 text-blue"
                      }, " ... "))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginationArray.value, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: p,
                      onClick: ($event: any) => (goToPage(p)),
                      class: _normalizeClass([p == _unref(filters).page ? 'text-white bg-primary' : 'text-blue bg-white', "px-4 py-2 list-none border border-gray-400"])
                    }, _toDisplayString(p), 11, _hoisted_110))
                  }), 128)),
                  (!paginationArray.value.includes(meta.value.pagination.total_pages - 1))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (goToPage(paginationArray.value[paginationArray.value.length - 1] + 1))),
                        class: "px-4 py-2 list-none bg-white border border-gray-400 text-blue"
                      }, " ... "))
                    : _createCommentVNode("", true),
                  (!paginationArray.value.includes(meta.value.pagination.total_pages))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (goToPage(meta.value.pagination.total_pages))),
                        class: "px-4 py-2 list-none bg-white border border-gray-400 text-blue"
                      }, _toDisplayString(meta.value.pagination.total_pages), 1))
                    : _createCommentVNode("", true)
                ], 64)),
            _createElementVNode("button", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (goToPage(_unref(filters).page + 1))),
              class: _normalizeClass(["flex items-center px-4 py-2 list-none border border-gray-400 rounded-r text-blue", { 'pointer-events-none': meta.value.pagination.total_pages < _unref(filters).page + 1 }])
            }, _hoisted_112, 2)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})